import { Component, OnInit } from "@angular/core";
import { UserService } from "@services/user.service";
import { HttpUtilService } from "@services/http-util.service";
import { environment } from "@env/environment";
import { ItemsService } from "@scaffold/services/items.service";
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { VerifyModalComponent } from "./verify-modal/verify-modal.component";
import { NotificationsService } from "@services/notifications.service";
import { MfaModalComponent } from "../mfa-modal/mfa-modal.component";
import {  take, tap } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { CognitoDomainService } from "@services/cognito-domain.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  public roleName = "";
  public hasMfa;
  public isLoading = true;
  userInfo = {
    picture: null,
    given_name: null,
    family_name: null,
    email: null,
    email_verified: null,
    phone_number: null,
    phone_number_verified: null,
  };
  emailVerificationCodeSent = false;
  phoneVerificationCodeSent = false;
  verificationCode = {
    email: {
      codeSent: false,
      code: null,
    },
    phone_number: {
      codeSent: false,
      code: null,
    },
  };

  profileView = null;
  editView = null;
  viewMode = true;
  profile = { data: {} };
  disableSave = false;
  public dialogRef: ScaffoldDialogRef;
  id: string;
  userAttributes$: any;
  isSSOEnabled: boolean;
  public cognitoSsoUrl$;

  constructor(
    public notification: NotificationsService,
    public dialog: ScaffoldDialogService,
    private userService: UserService,
    private httpUtils: HttpUtilService,
    private itemsService: ItemsService,
    private cognitoDomainServicer: CognitoDomainService
  ) {}

  ngOnInit() {
    this.cognitoSsoUrl$ =this.cognitoDomainServicer.getCognitoSsoUrl$().pipe(
      tap(({ cognitoSsoUrl }) => {
        this.isSSOEnabled = !!cognitoSsoUrl;
      })
    );

    this.httpUtils
      .request("get", environment.apiRoot + "/auth/checkuserpoolmfa")
      .subscribe((response) => {
        if (response === "OPTIONAL") this.hasMfa = true;
      });

    this.getProfileViews();

    this.userAttributes$ = combineLatest([
      this.userService.getRoleDetails(),
      this.userService.getCognitoUserAttributes$(),
    ]).pipe(
      take(1),
      tap(([role, cognitoUserAttribute]) => {
        this.roleName = role?.name || "";
        this.id = role.user_id;
        this.userInfo = role.data;
        // defer to cogntio for most up to date value of certain values
        if (typeof cognitoUserAttribute?.email_verified === "boolean") {
          this.userInfo.email_verified = cognitoUserAttribute.email_verified;
        }
        if (typeof cognitoUserAttribute?.phone_number_verified === "boolean") {
          this.userInfo.phone_number_verified =
            cognitoUserAttribute.phone_number_verified;
        }
      })
    );

    console.log(this.userInfo);
  }

  openVerifyModal(contactType) {
    let settings: any = {
      context: {
        data: {
          contactType,
        },
      },
    };
    this.dialogRef = this.dialog.open(VerifyModalComponent, settings);
    this.dialogRef.onClose.subscribe((result) => {
      // if result is truthy, it has been verified
      if (result) {
        this.userInfo[contactType + "_verified"] = true;
        this.userService.setUserInfo(this.userInfo);
      }
    });
  }

  saveProfile() {
    this.profile.data = this.itemsService.getData(this.profileView);
    this.httpUtils
      .request(
        "PUT",
        environment.apiRoot + "/users/" + this.id,
        this.profile,
        null,
        true,
        false,
        true
      )
      .subscribe((data) => {
        if (data.updated) {
          this.updateFieldsOnSuccess();
          this.userService.updateRoleInformation();
        } else {
          this.notification.popNotification(
            "",
            data.errorMessage
              ? `Error Updating Profile Info${data.errorMessage}`
              : "Error Updating"
          );
        }
        console.log("updated", data);
        this.userService.resetUserInfo().subscribe(() => {
          this.getProfileViews();
          this.viewMode = true;
          this.profile.data = {};
          this.disableSave = false;
          // Reset items service
          this.itemsService.cancelData();
        });

        this.userService.getCognitoUserAttributes$(true); //refreshes for all other subscribers of CognitoUserAttributes
      });
  }

  updateFieldsOnSuccess() {
    if (this.profile.data["email"]) this.userInfo.email_verified = false;
    if (this.profile.data["phone_number"])
      this.userInfo.phone_number_verified = false;

    this.userInfo = { ...this.userInfo, ...this.profile.data };
    this.notification.popNotification("", "Updated Profile Info");
  }

  private getProfileViews() {
    this.httpUtils
      .authGet(environment.apiRoot + "/users/self?mode=profile-read")
      .subscribe((data) => {
        this.isLoading = false;
        this.profileView = data;
      });

    this.httpUtils
      .authGet(environment.apiRoot + "/users/self?mode=profile-edit")
      .subscribe((data) => {
        this.editView = data;
      });
  }
  public openMfaOptions() {
    this.dialog.open(MfaModalComponent, {
      context: {
        data: { initialView: "options" },
      },
    } as any);
  }
}
